import {
  SbBlokData,
  StoryblokComponent,
  storyblokEditable,
} from "@storyblok/react";
import React from "react";
import ContentTitle from "../components/ContentTitle";

const OurMentors = ({ blok }: any) => {
  return (
    <div {...storyblokEditable(blok)}>
      <div className="mx-8 md:mx-[15%] xl:mx-[20%] mt-10">
        <ContentTitle
          icon={blok.title[0].icon.icon}
          title={blok.title[0].title}
          subtitle={blok.title[0].subtitle}
        />
      </div>
      <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-8 mx-8 md:mx-[5%] xl:mx-[10%] mt-5 mb-10">
        {blok.mentors.map((nestedBlok: SbBlokData) => {
          return <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />;
        })}
      </div>
    </div>
  );
};

export default OurMentors;
